import {Pipe, PipeTransform} from "@angular/core";
import {TextUtils} from "../utils/text-utils";
import {Store} from "@ngrx/store";
import * as fromStore from '../../store';

@Pipe({
  name: 'dbText',
  standalone: true
})

export class DbTextPipe implements PipeTransform {
  private companyName: string = 'Dashboard';

  constructor(private _store: Store<fromStore.DbStoreState>) {
    this._store.select(fromStore.getCompanyInfo)
      .subscribe((companyInfo: any) => {
        if (companyInfo) {
          this.companyName = companyInfo?.branding?.company_name || companyInfo?.agency?.name || 'YourBrand';
        }
      });
  }

  transform(text: string, params: any = null): string | null {
    const translatedText = TextUtils.getText(text, params) || `TEXT_NOT_FOUND::${text}`;
    return translatedText.replace(/10Web/gi, this.companyName);
  }

}
